import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const SAAuthContext = createContext(null);

export function SAAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    try {
      const { data } = await api.get("/admin/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const logout = async () => {
    try { await api.post("/admin/auth/logout"); } catch {}
    setUser(null);
    window.location.href = "/admin/login";
  };

  return (
    <SAAuthContext.Provider value={{ user, setUser, loading, logout, refresh: check }}>
      {children}
    </SAAuthContext.Provider>
  );
}

export function useSAAuth() { return useContext(SAAuthContext); }
